import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📙',
    title: 'Tomo 1 — El Despertar Digital',
    sessions: 'Mentalidad y ecosistema de MeLi',
    months: 'Fundamentos · Algoritmo · Modelos de negocio',
    desc: 'Entendé cómo piensa MeLi antes de publicar.',
    color: 'bg-[#FF6B00]',
    borderColor: 'border-t-[#FF6B00]'
  }, {
    emoji: '📘',
    title: 'Tomo 2 — El Escudo Fiscal',
    sessions: 'AFIP, IIBB, Monotributo y retenciones',
    months: 'Impuestos · Retenciones · Contador digital',
    desc: 'Pagá exactamente lo que corresponde. Ni un peso más.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Tomo 3 — Radar de Rentabilidad',
    sessions: 'Encontrá los productos que dejan ganancia',
    months: 'Nichos · Márgenes · Investigación de mercado',
    desc: 'Elegí bien antes de invertir en stock.',
    color: 'bg-[#EF4444]',
    borderColor: 'border-t-[#EF4444]'
  }, {
    emoji: '📓',
    title: 'Tomo 4 — La Fábrica de Clicks',
    sessions: 'Publicaciones que dominan el algoritmo',
    months: 'Títulos SEO · Fotos · Descripciones · Fichas técnicas',
    desc: 'Aparecer primero no es suerte. Es sistema.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📗',
    title: 'Tomo 5 — La Máquina Operativa',
    sessions: 'Operación diaria sin caos',
    months: 'Full · Flex · Stock · Atención · Reputación',
    desc: 'El negocio que opera bien vende más sin trabajar más.',
    color: 'bg-[#10B981]',
    borderColor: 'border-t-[#10B981]'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — El Salto del Dueño',
    sessions: 'De vendedor a empresario digital',
    months: 'Escala · Equipo · Automatización · Crecimiento',
    desc: 'Dejá de operar el negocio. Empezá a dirigirlo.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }];
  const features = ['Algoritmo de MeLi explicado y aplicado', 'Sistema fiscal y retenciones ordenado', 'Publicaciones que aparecen primero', 'Full y Flex implementados correctamente', 'Calculadora de ganancia real incluida', 'Prompts de IA para todo el negocio'];
  const featureChips = ['✅ Algoritmo de MeLi explicado y aplicado', '✅ Sistema fiscal y retenciones ordenado', '✅ Publicaciones que aparecen primero', '✅ Full y Flex implementados correctamente', '✅ Calculadora de ganancia real incluida', '✅ Prompts de IA para todo el negocio'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-18" data-mp="lj87z0d9gde0">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19" data-mp="vmdktw54cqrr">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20" data-mp="vk0uaulap833">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full border border-brandYellow/30" style={{
          background: '#1B2236',
          color: '#FFE600',
          boxShadow: '0 2px 8px rgba(255,230,0,0.1)'
        }} data-id="element-21" data-mp="qmivhx0zs98t">
            🏆 Sistema N°1 para comerciantes que venden en Mercado Libre
            Argentina
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[44px] text-[32px]" data-id="element-22" data-mp="14l8rtafzm4w4">
          MEGAPACK COMERCIO PRODUCTIVO{' '}
          <span className="text-[#FFE600]" data-id="element-23" data-mp="1x4ebvu916c8t">2026™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-24" data-mp="1scntr23uqk6u">
          6 Tomos + 6 Bonos — Sistema completo para vender, rankear y escalar en
          MeLi Argentina
        </p>
      </FadeIn>

      {/* Colored book strip with emoji */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-25" data-mp="1hrd0dyp8ppxy">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-26" data-mp="13uztfjic16xq">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[44px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-27" data-mp="17w1vs97jpz3x" data-mpi={i}>
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-28" data-mp="1qu5ppwev3rl5"></div>
              <span className="font-sans font-bold uppercase tracking-[1px] text-[8px] md:text-[10px] leading-tight drop-shadow-md relative z-10 text-white" data-id="element-29" data-mp="2ejgk8w5mcpqu">
                Tomo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-30" data-mp="7twunqeikcb1">
          <span className="inline-block bg-brandYellow text-brandNavy font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full shadow-sm" data-id="element-31" data-mp="2xeqosr0chzr">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-32" data-mp="3l29mevk286tq">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-33" data-mp="3l319fhzlcw8e">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandYellow/10 text-brandYellow border border-brandYellow/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-34" data-mp="3v0yszs6ia4uo" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-35" data-mp="1cebsjdd8px10">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandYellow/50 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-36" data-mp="1cds7hnsamsir">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandYellow" data-id="element-37" data-mp="1mchrbm3r2n1n">
            📦 Lo que recibís:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-38" data-mp="tnu43kzfxnlg">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-39" data-mp="13m04tz9ignoq" data-mpi={i}>
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-3 md:p-6 border-y border-r transition-all border-l-[4px] ${isOpen ? 'border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : `border-y-line border-r-line border-l-brandYellow`}`} aria-expanded={isOpen} data-id="element-40" data-mp="13kfb2bv0t8rx">
                <div className="flex items-start justify-between gap-3" data-id="element-41" data-mp="2p5d8y0bcopyu">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-42" data-mp="2p2zik4rm81xm">
                    <div className="text-xl md:text-4xl shrink-0" data-id="element-43" data-mp="2k462c4ky1wtr">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-44" data-mp="2a7t9ta14xp0l">
                      <h3 className="font-sans font-bold text-[14px] md:text-xl text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-45" data-mp="2a8mjojve4umy">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-46" data-mp="21gkjmmp8hgd7">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandYellow bg-brandYellow/10 px-2 py-0.5 rounded" data-id="element-47" data-mp="1wgem4pwa8zn7">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-bg-highlight px-2 py-0.5 rounded" data-id="element-48" data-mp="1mjjsakayfnf9">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandYellow text-brandNavy rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-49" data-mp="31dqfcbcicmiu">
                    {isOpen ? <Minus size={14} data-id="element-50" data-mp="2wfyqjq75tgiv" /> : <Plus size={14} data-id="element-51" data-mp="2wggiiamsh8kz" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-52" data-mp="2ip1wrw1hyta8">
                  <div className="overflow-hidden" data-id="element-53" data-mp="28qvxlm72s192">
                    <p className="font-sans font-bold text-[13px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-54" data-mp="2doeatos4l2mv">
                      "{tomo.desc}"
                    </p>
                    <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandGold" data-id="element-55" data-mp="1u4yomgrkcvm3">
                      Contenido de alto valor · Listo para aplicar desde hoy
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-56" data-mp="2d0yglrkjjz5o">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-57" data-mp="2d0f78z8yij39">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-58" data-mp="28zmz69btmk8k">
            Leés el programa, seguís el paso a paso y aplicás.
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-59" data-mp="2ht01u2zot07u">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-60" data-mp="2wncvn9h21hbn" data-mpi={i}>
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-61" data-mp="2rsh4scnk1004" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-62" data-mp="2qz3kc5q06ldy">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-63" data-mp="2h891lbbyu3x9">
            <p className="font-sans font-bold text-base md:text-xl leading-snug text-[#FFE600]" data-id="element-64" data-mp="2d6npvtb63von">
              Sin experiencia previa. Sin información confusa. Un sistema simple
              para pasar de cero a tus primeras ventas en Mercado Libre.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🚀',
    title: 'Setup Express Mercado Libre 2026',
    desc: 'Configurá tu cuenta como profesional desde el día 1. Cada paso sin errores.',
    value: '$15.000'
  }, {
    num: '02',
    icon: '🏪',
    title: 'Puente al Digital',
    desc: 'Guía para comerciantes físicos que nunca vendieron online. Tu negocio del local a MeLi.',
    value: '$12.000'
  }, {
    num: '03',
    icon: '💬',
    title: 'Pack de Respuestas y Publicaciones Pro',
    desc: 'Plantillas listas para responder preguntas, manejar reclamos y comunicar como profesional.',
    value: '$10.000'
  }, {
    num: '04',
    icon: '🧮',
    title: 'Calculadora de Ganancia Real',
    desc: 'Calculá el precio correcto de cada producto antes de publicar. Nunca más márgenes sorpresa.',
    value: '$12.000'
  }, {
    num: '05',
    icon: '🤖',
    title: 'Prompt Bank IA Para Vendedores de MeLi',
    desc: '+50 prompts listos para investigar, publicar, atender y crecer usando inteligencia artificial.',
    value: '$15.000'
  }, {
    num: '06',
    icon: '📅',
    title: 'Desafío 30 Días Para Activar tu Negocio',
    desc: 'Plan diario con tarea concreta por día. De cero a primera venta en 30 días.',
    value: '$10.000'
  }];
  return <Section className="bg-bg-alt" data-id="element-65" data-mp="5ncmthgd5ktc">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-66" data-mp="5oebwpu7s7u2">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-2 md:mb-4 text-[34px]" data-id="element-67" data-mp="oi5yl1yi6bv">
          + 6 BONOS <span className="text-[#FFE600]" data-id="element-68" data-mp="eokmo3yj2tpj">ESTRATÉGICOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-69" data-mp="akv01k1eym75">
          Incluidos en todas las ofertas — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-4 mb-8 md:mb-12" data-id="element-70" data-mp="jlb2cq6f7naf">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-71" data-mp="yafim1tnnhfw" data-mpi={i}>
            <div className="bg-bg-card rounded-[12px] p-2.5 md:p-4 border border-line border-l-[4px] border-l-brandYellow h-full relative overflow-hidden flex flex-col" data-id="element-72" data-mp="tbvupvvi3vkw">
              <div className="absolute -right-1 -top-2 text-[36px] md:text-[64px] font-display font-black text-white/5 leading-none" data-id="element-73" data-mp="12cu46topkvav">
                {bono.num}
              </div>
              <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-74" data-mp="1lwj4aqx1jj0z">
                <div className="flex items-center gap-1.5" data-id="element-75" data-mp="1qx6yflgkgfzf">
                  <span className="text-lg md:text-xl" data-id="element-76" data-mp="1cypbvr2ed9j3">🎁</span>
                  <div className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandYellow" data-id="element-77" data-mp="1d0a4vc92ckeu">
                    BONO {bono.num}
                  </div>
                </div>
                <span className="text-lg md:text-xl" data-id="element-78" data-mp="17yuklmepmhxi">{bono.icon}</span>
              </div>
              <h3 className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-79" data-mp="180nudakmdi9q">
                {bono.title}
              </h3>
              <p className="font-sans text-[11.5px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-80" data-mp="y9kqk10b2p6r">
                {bono.desc}
              </p>
              <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-81" data-mp="p7bjxm85rfyn">
                <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-82" data-mp="h75l73cp7ulj">
                  {bono.value}
                </span>
                <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-83" data-mp="7hcbk7w49pjx">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-84" data-mp="3pngweae1nc8e">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-85" data-mp="3kp5mjznr11q6">
          Valor total de los 6 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-86" data-mp="1ix0v0pa5w6fz">
          $74.000
        </p>
        <p className="font-display font-black text-[24px] md:text-[44px] leading-[1.1] mb-1 md:mb-2 text-[#22C55E]" data-id="element-87" data-mp="1ev5wttnj296f">
          🎁 GRATIS — Solo con tu MEGAPACK
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-88" data-mp="31s5asdld3u58">
          Incluidos en todas las ofertas. Siempre.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-89" data-mp="3ama2t0c8fbmc">
      <div className="max-w-[1100px] mx-auto" data-id="element-90" data-mp="2dw9et3josz63">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-91" data-mp="2isho40b7dy5c">
          <div className="rounded-[20px] border-2 border-brandYellow p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto shadow-[0_0_20px_rgba(255,230,0,0.1)]" data-id="element-92" data-mp="2itj9oypui31b">
            <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandYellow" data-id="element-93" data-mp="2ruqymq6h1riq">
              ⏰ OFERTA DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center gap-2.5 md:gap-4 text-white" data-id="element-94" data-mp="7377toch5ny3">
              <div className="bg-bg-highlight border border-line rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center" data-id="element-95" data-mp="236v69pnp587d">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandYellow leading-none" data-id="element-96" data-mp="1z508uw8vzeyv">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandYellow mt-1" data-id="element-97" data-mp="286hjhz3iyog6">
                  hs
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-txt-primary flex items-center" data-id="element-98" data-mp="1filtfd8gnusd">
                :
              </div>
              <div className="bg-bg-highlight border border-line rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center" data-id="element-99" data-mp="1peyifxt29kgs">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandYellow leading-none" data-id="element-100" data-mp="11nt6htq8rcbr">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandYellow mt-1" data-id="element-101" data-mp="38c1saznwii0g">
                  min
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-txt-primary flex items-center" data-id="element-102" data-mp="2zfayyv0qhh9k">
                :
              </div>
              <div className="bg-bg-highlight border border-line rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center" data-id="element-103" data-mp="3r4e5yik095pw">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandYellow leading-none" data-id="element-104" data-mp="3i3y39bb362m3">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandYellow mt-1" data-id="element-105" data-mp="3n4vibf0sugjd">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-txt-primary leading-snug" data-id="element-106" data-mp="32dpd2x7c67p4">
              <AlertTriangle size={20} className="text-brandGold" data-id="element-107" data-mp="2ybkmk7c6pr6p" />
              <span data-id="element-108" data-mp="2tcr6c75ijm2u">Después vuelve a su precio original. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-109" data-mp="2oefyg1ys3ln9">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-110" data-mp="2ogiyletnav5p">
                <span className="flex items-center gap-2" data-id="element-111" data-mp="3h33k3ynfwd1c">
                  <span className="w-2 h-2 rounded-full bg-brandYellow animate-pulse" data-id="element-112" data-mp="3h4ya3rdkivca"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandYellow font-bold" data-id="element-113" data-mp="37c90l21kvrjl">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-114" data-mp="8ntptcpskc44">
                <div className="bg-brandYellow h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-115" data-mp="3w1u6nrs3g74"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-116" data-mp="g7m9c0hphuwn">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const checkoutUrl = PRODUCTS[selected].checkoutUrl;
  const ctaText = selected === 'plus' ? 'SÍ, QUIERO EL SISTEMA COMPLETO' : 'QUIERO EL MEGAPACK';
  return <Section className="bg-bg-alt" id="pricing" data-id="element-117" data-mp="13xgl0eqahdfb">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-118" data-mp="18v8hlm1vpnpu">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary text-[40px]" data-id="element-119" data-mp="18up3kgfcnjh3">
          Elegí tu <span className="text-[#FFE600]" data-id="element-120" data-mp="1ds8fvashlm6e">MEGAPACK:</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] text-txt-body mt-2" data-id="element-121" data-mp="1hwpzn9yujzh6">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-4 md:space-y-5" data-id="element-122" data-mp="2mabswo3h8ebf">
        {/* Option Plus - MÁS ELEGIDO (first) */}
        <FadeIn delay={0.1} data-id="element-123" data-mp="2r9eyc9ndcmjx">
          <button onClick={() => setSelected('plus')} className={`w-full text-left rounded-[16px] md:rounded-[20px] p-3.5 md:p-6 transition-all duration-300 border-2 bg-bg-card relative ${selected === 'plus' ? 'border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : 'border-line hover:border-brandGold'}`} data-id="element-124" data-mp="2rcavhvre777b">
            {selected === 'plus' && <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2 text-brandNavy font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] px-2.5 md:px-3.5 py-0.5 md:py-1 rounded-full whitespace-nowrap bg-brandYellow" data-id="element-125" data-mp="3a1heljw3m0tn">
                ⭐ MÁS ELEGIDO
              </div>}
            <div className="flex items-start gap-2.5 md:gap-4" data-id="element-126" data-mp="3ny4d3r3p8z1o">
              <div className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-2 mt-0.5 md:mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandYellow' : 'border-line'}`} data-id="element-127" data-mp="1cdwwofu4bf44">
                {selected === 'plus' && <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brandYellow" data-id="element-128" data-mp="ye47ioy8p6y9"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-129" data-mp="1v33g652qkaqz">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-130" data-mp="1r29t1dx4azz5">
                  <span className="text-base md:text-xl" data-id="element-131" data-mp="1mbb6vxpg77nz">🏆</span>
                  <h3 className="font-sans font-bold text-[13px] md:text-xl text-txt-primary leading-snug" data-id="element-132" data-mp="1m9gpgtddxxon">
                    MEGAPACK +{' '}
                    <span className="transition-colors text-[#FFE600]" data-id="element-133" data-mp="2es43jotyscg8">
                      POTENCIADORES
                    </span>
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2 mb-1.5 md:mb-3" data-id="element-134" data-mp="2sx4ezhcdcp42">
                  <span className="bg-success/90 text-white font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-2 md:px-2.5 py-0.5 md:py-1 rounded-full" data-id="element-135" data-mp="2sxwayt9voouv">
                    AHORRÁS $15.000 🔥
                  </span>
                </div>
                <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.4] md:leading-[1.5] text-txt-body" data-id="element-136" data-mp="2o5mc2nqscegg">
                  6 Tomos + 6 Bonos +{' '}
                  <span className="font-bold transition-colors text-[#FFE600]" data-id="element-137" data-mp="2a8zeqjux7ma0">
                    ✨ 6 Volúmenes Potenciadores
                  </span>
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-138" data-mp="2181d287yfqul">
                <p className="font-sans font-normal text-[12px] md:text-[18px] line-through text-danger" data-id="element-139" data-mp="258l6b0peqabg">
                  $57.990
                </p>
                <p className={`font-display font-black text-[24px] md:text-[52px] leading-none ${selected === 'plus' ? 'text-brandYellow' : 'text-txt-primary'}`} data-id="element-140" data-mp="3vi4zeqbfmkjr">
                  $34.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Option Basic */}
        <FadeIn delay={0.2} data-id="element-141" data-mp="1xoaolar9s38d">
          <button onClick={() => setSelected('basic')} className={`w-full text-left rounded-[16px] md:rounded-[20px] p-3.5 md:p-6 transition-all duration-300 border-2 bg-bg-card ${selected === 'basic' ? 'border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : 'border-line hover:border-brandGold'}`} data-id="element-142" data-mp="1xpbwx7gwibme">
            <div className="flex items-start gap-2.5 md:gap-4" data-id="element-143" data-mp="2gmmw6s2j951u">
              <div className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-2 mt-0.5 md:mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandYellow' : 'border-line'}`} data-id="element-144" data-mp="2gm3lnwf7pixu">
                {selected === 'basic' && <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brandYellow" data-id="element-145" data-mp="hb2j37aac59t"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-146" data-mp="jqij0ifm0ipe">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-147" data-mp="np9gwrrwg4dk">
                  <span className="text-base md:text-xl" data-id="element-148" data-mp="souht7qmqmsx">📘</span>
                  <h3 className="font-sans font-bold text-[13px] md:text-xl text-txt-primary leading-snug" data-id="element-149" data-mp="snb2pkgpmhsq">
                    MEGAPACK{' '}
                    <span className="transition-colors text-[#FFE600]" data-id="element-150" data-mp="1huuwgk4cz3">
                      COMERCIO PRODUCTIVO 2026
                    </span>
                  </h3>
                </div>
                <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.4] md:leading-[1.5] text-txt-body" data-id="element-151" data-mp="9ycrf9t9s3aq">
                  6 Tomos Completos + 6 Bonos incluidos
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-152" data-mp="3debizqndyz9d">
                <p className="font-sans font-normal text-[12px] md:text-[18px] line-through text-danger" data-id="element-153" data-mp="3ddigx2zdgxxk">
                  $39.990
                </p>
                <p className={`font-display font-black text-[24px] md:text-[52px] leading-none ${selected === 'basic' ? 'text-brandYellow' : 'text-txt-primary'}`} data-id="element-154" data-mp="3atlvjxth4cco">
                  $22.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Single CTA */}
        <FadeIn delay={0.3} data-id="element-155" data-mp="2w00hqtt7zke1">
          <div className="pt-2 md:pt-4" data-id="element-156" data-mp="2rwkpsas3i87o">
            <div className="text-center mb-2.5 md:mb-3" data-id="element-157" data-mp="2rxm3kn0hx8t3">
              <p className="font-sans font-bold text-[12px] md:text-[14px] text-txt-primary leading-snug" data-id="element-158" data-mp="2n4svbp5tjic9">
                👇 Tu primer venta profesional en MeLi empieza acá
              </p>
              <p className="font-sans text-[10.5px] md:text-[12px] text-brandGold uppercase tracking-[1.5px] font-bold mt-1 animate-pulse" data-id="element-159" data-mp="2d7ojai5ot396">
                ⚡ Precio de lanzamiento — por tiempo limitado
              </p>
            </div>
            <CTAButton href={checkoutUrl} fullWidth trackingProduct={selected} data-id="element-160" data-mp="247rrw8rwxqaf">
              {ctaText}
            </CTAButton>
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-3 md:mt-4 font-sans text-[11px] md:text-[13px] text-txt-muted" data-id="element-161" data-mp="1tnhb8r1bycvb">
              <span data-id="element-162" data-mp="1kl83ua1cyzm5">🔒 Pago 100% seguro</span>
              <span data-id="element-163" data-mp="1kmj2xwjuzj6x">⚡ Acceso en 5 minutos</span>
              <span data-id="element-164" data-mp="1pj9jsm3hmite">🛡️ Garantía 15 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Publicaciones en la página 3',
    good: 'Publicaciones en el top 3 del buscador'
  }, {
    bad: 'Publicidad que gasta sin retorno',
    good: 'Campañas con RETORNO 5x validado'
  }, {
    bad: 'Retenciones de IIBB perdidas',
    good: 'Retenciones computadas como crédito fiscal'
  }, {
    bad: 'Despacho manual que consume 4 horas diarias',
    good: 'Full operando: 10 minutos diarios de logística'
  }, {
    bad: 'Vendés un producto por transacción',
    good: 'Combos que duplican el ticket promedio'
  }, {
    bad: 'Negocio que depende de que estés presente',
    good: 'Sistema automático que vende mientras dormís'
  }];
  const volumes = [{
    icon: '🔍',
    title: 'Vender Primero',
    sub: 'Dominá el Buscador',
    desc: 'Aparecer #1 en MeLi sin bajar el precio. SEO avanzado, títulos que rankean y el algoritmo de tu lado.',
    chapters: '6 capítulos · Sistema completo'
  }, {
    icon: '📢',
    title: 'Publicidad Rentable',
    sub: 'Gastá Menos, Vendé Más',
    desc: 'Mercado Ads con ROAS 5x desde el día 1. Meta Ads y Google Ads para traer tráfico a MeLi.',
    chapters: '8 capítulos · Campañas listas'
  }, {
    icon: '📦',
    title: 'Envíos Rápidos',
    sub: 'El Secreto de Full y Flex',
    desc: 'Activar Full correctamente para vender más, rankear mejor y eliminar el trabajo de despacho.',
    chapters: '8 capítulos · Implementación total'
  }, {
    icon: '🧾',
    title: 'Impuestos Inteligentes',
    sub: 'Protegé tu Plata',
    desc: 'AFIP, IIBB, Monotributo y Convenio Multilateral. Pagá lo justo y recuperá las retenciones.',
    chapters: '8 capítulos · Estrategia fiscal'
  }, {
    icon: '🎁',
    title: 'Combos Explosivos',
    sub: 'Subí tu Ticket de Venta',
    desc: 'Vender 2 o 3 productos en lugar de 1. Kits, upselling y cross-selling que funcionan en MeLi.',
    chapters: '8 capítulos · Más ganancia por venta'
  }, {
    icon: '🤖',
    title: 'Negocio Automático',
    sub: 'Vendé Mientras Dormís',
    desc: 'IA y automatización para que tu tienda de MeLi funcione sola. Full + IA + Panel de control.',
    chapters: '8 capítulos · Piloto automático'
  }];
  return <Section className="bg-bg-base" data-id="element-165" data-mp="13hmt6zgq0ndv">
      <FadeIn className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-166" data-mp="13io7rdwy3s0c">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary mb-4 md:mb-6" data-id="element-167" data-mp="18h98deg40dpb">
          🚀 ¿QUÉ AGREGAN LOS{' '}
          <span className="text-[#FFE600]" data-id="element-168" data-mp="w68hs1ac7lms">POTENCIADORES?</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-169" data-mp="w3vtl6dzkf1a">
          El MEGAPACK resuelve el problema base. Los Potenciadores te dan{' '}
          <strong className="text-txt-primary" data-id="element-170" data-mp="m9lwjbe3msk8">
            dominio total en las 6 áreas más rentables del ecommerce argentino.
          </strong>
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="max-w-6xl mx-auto mb-12 md:mb-16" data-id="element-171" data-mp="1exhpq64gm2c9">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-8 md:mb-10" data-id="element-172" data-mp="19wu27uffw3ms">
          {volumes.map((vol, i) => <div key={i} className="bg-bg-card border border-line rounded-[14px] md:rounded-[16px] p-3 md:p-5 hover:border-brandYellow transition-all flex flex-col" data-id="element-173" data-mp="15v8gdjkxgf0g" data-mpi={i}>
              <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-174" data-mp="3qkpjw955p3k2">
                <div className="text-xl md:text-3xl shrink-0" data-id="element-175" data-mp="2pe54xpjdeid9">{vol.icon}</div>
                <div className="min-w-0" data-id="element-176" data-mp="2kf1xxzjty22n">
                  <h4 className="font-display font-black uppercase text-[15px] md:text-[22px] leading-[1.1] text-txt-primary mb-0.5" data-id="element-177" data-mp="2kg3hksewvwvz">
                    {vol.title}
                  </h4>
                  <p className="font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[11px] text-[#FFE600]" data-id="element-178" data-mp="2uaverv4l0hq8">
                    {vol.sub}
                  </p>
                </div>
              </div>
              <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.45] md:leading-[1.6] text-txt-body mb-2.5 md:mb-4 flex-grow" data-id="element-179" data-mp="3i20vsdm9dg24">
                {vol.desc}
              </p>
              <div className="bg-bg-highlight text-txt-body font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[11px] inline-block px-2 md:px-2.5 py-0.5 md:py-1 rounded-md self-start" data-id="element-180" data-mp="3d0v66onwa8wt">
                {vol.chapters}
              </div>
            </div>)}
        </div>

        <div className="bg-bg-card border-2 border-brandYellow rounded-[20px] p-5 md:p-8 text-center max-w-3xl mx-auto" data-id="element-181" data-mp="35z6vwlk1qa9">
          <p className="font-display font-black uppercase text-[22px] md:text-[40px] leading-[1.15] text-txt-primary mb-1 md:mb-2" data-id="element-182" data-mp="3kn0by1sloo87">
            Dominio total en las 6 áreas más rentables del ecommerce argentino
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-183" data-mp="3bnvdevh1guw1">
        <div className="bg-bg-card rounded-[20px] overflow-hidden border border-line" data-id="element-184" data-mp="3gler9u9tr5ng">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5 text-center" data-id="element-185" data-mp="31nurd1rsc0o5">
            <div className="font-sans font-bold text-[13px] md:text-[16px] text-txt-muted" data-id="element-186" data-mp="36mpiqs3tixjv">
              ❌ Sin Potenciadores
            </div>
            <div className="font-sans font-bold text-[13px] md:text-[16px] text-success" data-id="element-187" data-mp="zxaz1ubgjci5">
              ✅ Con Potenciadores
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-188" data-mp="13e5muvowtxc8">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5" data-id="element-189" data-mp="13bszu44aowsb" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-muted pr-2 md:pr-4" data-id="element-190" data-mp="tf7qx7p5n1j7">
                  {row.bad}
                </div>
                <div className="font-sans text-[12px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-primary pl-2 md:pl-4 border-l border-line" data-id="element-191" data-mp="1m4dn961869oq">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};